module.exports = __webpack_public_path__ + "img/slider-536e5f02.png";